'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _button = require('../button');

var _button2 = _interopRequireDefault(_button);

var _modalLocal = require('./modal.local.css');

var _modalLocal2 = _interopRequireDefault(_modalLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ModalSaveFooter = function ModalSaveFooter(_ref) {
  var onSave = _ref.onSave,
      closeModal = _ref.closeModal,
      saveEnabled = _ref.saveEnabled,
      isLoading = _ref.isLoading,
      cancelText = _ref.cancelText,
      saveText = _ref.saveText;
  return _react2.default.createElement('footer', {
    className: _modalLocal2.default.saveModalFooter
  }, _react2.default.createElement(_button2.default, {
    size: 'medium',
    theme: 'outline',
    color: 'grayscale-hc',
    onClick: closeModal,
    'data-auto': 'cancelButton'
  }, cancelText), onSave && _react2.default.createElement(_button2.default, {
    size: 'medium',
    color: 'primary-hc',
    onClick: onSave,
    disabled: !saveEnabled || isLoading,
    spinner: isLoading,
    'data-auto': 'saveButton'
  }, saveText));
};

ModalSaveFooter.defaultProps = {
  saveEnabled: true,
  isLoading: false,
  cancelText: 'Cancel',
  saveText: 'Save'
};
ModalSaveFooter.propTypes = {
  saveEnabled: _propTypes2.default.bool,
  isLoading: _propTypes2.default.bool,
  onSave: _propTypes2.default.func,
  saveText: _propTypes2.default.string,
  cancelText: _propTypes2.default.string,
  closeModal: _propTypes2.default.func.isRequired
};
exports.default = ModalSaveFooter;